import { Auth } from 'AuthBundle'
import { ViewServices } from './ViewServices.js'
import { Snackbar } from 'InterfaceBundle'

/**
 * Real time communication from front to back using sockets
 */
export const Realtime = {
	socket: null,
	ready: false,
	authCb: false,
	credentialsChanging: false,
	_cbs: [],
	_nextId: 1,
	_ackCbs: {},
	_emitStack: [],
	_sendStack: [],
	_closeEventListener: null,

	_initialize() {
		if(!this.socket) {
			if(!Auth.isAuthenticated()) this._close()
			else {
				let url = location.origin.replace('http://', 'ws://').replace('https://', 'wss://') + '/rt/'
				url += '?token=' + Auth.getToken()
				if(Auth.isImpersonating()) url += '&impersonate=' + Auth.isImpersonating()
				this.socket = new WebSocket(url)
				this._closeEventListener = () => this._close()
				this.socket.addEventListener('message', data => this._handleMessage(data))
				this.socket.addEventListener('error', () => {
					this.socket.removeEventListener('close', this._closeEventListener)
					this._close()
				})
				this.socket.addEventListener('close', this._closeEventListener)
			}
		}
		if(!this.authCb) {
			this.authCb = true
			Auth.events.logout.subscribe(() => this._close(true, false))
			Auth.events.credentialsChanged.subscribe(() => {
				this.credentialsChanging = true
				this._close(true, true)
			})
		}
	},

	_close(close = false, reconnect = true) {
		if(this.socket) {
			if(close && this.socket) this.socket.close()
			this.ready = false
			this.socket = null
			for(let cb of this._cbs) {
				if(cb.event == '_status' && !this.credentialsChanging) cb.cb(false)
			}
		}
		if(reconnect && Auth.isAuthenticated()) setTimeout(() => this._initialize(), 1000)
	},

	_authenticated() {
		if(this.socket) {
			this.credentialsChanging = false
			this.ready = true
			for(let item of this._emitStack) this.emit(item.event, item.data)
			this._emitStack = []
			for(let item of this._sendStack) this.socket.send(item)
			this._sendStack = []
			for(let cb of this._cbs) {
				if(cb.event == '_status') cb.cb(true)
			}
		}
	},

	_handleMessage(data) {
		if(data.data == '_authenticated') this._authenticated()
		else if(['_ackok', '_ackko'].includes(data.data.substr(0, 6))) {
			let uid = data.data.substr(6)
			let ok = data.data.substr(0, 6) == '_ackok'
			if(!ok) Snackbar.open({text: 'An error occurred', error: true})
			if(this._ackCbs[uid]) {
				for(let cb of this._ackCbs[uid]) cb(ok)
				delete this._ackCbs[uid]
			}
		}
		else {
			let messageContent = JSON.parse(data.data)
			for(let cb of this._cbs) {
				if(cb.event == messageContent.event) cb.cb(messageContent.data)
			}
		}
	},

	_cancel(id) {
		this._cbs = this._cbs.filter(c => c.id != id)
	},

	status() {
		return this.listen('_status')
	},

	/**
	 * Listen to event
	 * @param  {string}  event
	 * @return {Promise}
	 */
	listen(event) {
		this._initialize()
		let id = this._nextId
		this._nextId++
		return {
			then: cb => this._cbs.push({event: event, cb: cb, id: id}),
			unsubscribe: () => this._cancel(id)
		}
	},

	/**
	 * Emit event
	 * @param  {string} event
	 * @param  {object} data
	 * @return {Promise}
	 */
	emit(event, data = null) {
		this._initialize()
		let uid = Date.now().toString(36) + Math.random().toString(36).substr(2)
		let request = JSON.stringify({
			event: event,
			data: data,
			_uid: uid
		})
		if(this.ready) this.socket.send(request)
		else this._sendStack.push(request)
		return {
			then: cb => {
				if(!this._ackCbs[uid]) this._ackCbs[uid] = []
				this._ackCbs[uid].push(cb)
			},
			_uid: uid
		}
	}
}

ViewServices.realtime = Realtime